import {
  MfaIdentitiesList,
  type MfaIdentity,
  type MFAIdentityType,
  type MfaRequiredResponseData,
  type TwoFA,
} from '@/entities/mfa-identity';
import { useModalStore } from '@/shared/lib/modalStore';
import { MfaConfirmationModal } from '../ui/MfaConfirmationModal';

type MfaIdentitiesModalArgs = {
  availableIdentities: Array<MfaIdentity>;
  onSelectIdentity: (identity: MFAIdentityType) => void;
};

type OpenMfaConfirmationModalArgs = {
  onBack: () => void;
  requestFn: (twoFA: TwoFA) => Promise<unknown>;
  mfaData: MfaRequiredResponseData;
  onSuccess: (response: unknown) => void;
};

const useMfaIdentitiesModal = () => {
  const { showDialogComponent } = useModalStore();

  const openMfaIdentitiesModal = ({
    availableIdentities,
    onSelectIdentity,
  }: MfaIdentitiesModalArgs) => {
    showDialogComponent({
      component: (
        <MfaIdentitiesList
          availableIdentities={availableIdentities}
          onSelectIdentity={onSelectIdentity}
        />
      ),
      className: 'bg-secondary-bg',
    });
  };

  const openMfaConfirmationModal = ({
    onBack,
    requestFn,
    mfaData,
    onSuccess,
  }: OpenMfaConfirmationModalArgs) => {
    showDialogComponent({
      component: (
        <MfaConfirmationModal
          onBack={onBack}
          requestFn={requestFn}
          mfaData={mfaData}
          onSuccess={onSuccess}
        />
      ),
    });
  };

  return {
    openMfaIdentitiesModal,
    openMfaConfirmationModal,
  };
};

export { useMfaIdentitiesModal };
